export const KeyboardKeys = {
    ARROW_DOWN: "ArrowDown",
    ARROW_UP: "ArrowUp",
    SPACE: "Space",
    ENTER: "Enter",
    ESCAPE: "Escape",
    TAB: "Tab",
};
//# sourceMappingURL=types.js.map
